import { questionnaireFeedback } from "@repo/questionnaire";
import type { QuestionnaireRunnerProps } from "./questionnaire-runner-types";
import type { QuestionnaireState } from "./use-questionnaire-state";

export function QuestionnaireFeedback({
  props,
  state,
}: {
  props: QuestionnaireRunnerProps;
  state: QuestionnaireState;
}) {
  if (
    props.feedbackScope === false ||
    state.reviewStep ||
    state.pageField ||
    state.returnToReviewRef.current ||
    props.jumpToStepId ||
    state.actionError ||
    Object.keys(state.fieldErrors).length > 0
  )
    return null;
  const message = questionnaireFeedback({
    definition: props.definition,
    answers: state.answers,
    stepId: state.flow.currentStep.id,
    scope: props.feedbackScope || "section",
    hasIntroduction: Boolean(props.firstStepIntro),
  });
  if (!message) return null;
  return (
    <p
      data-questionnaire-feedback
      className="text-sm leading-relaxed text-muted-foreground"
    >
      {state.chromeLabel(message)}
    </p>
  );
}
